import {
  REVIEW_TYPES_RR_DEMO,
  REVIEW_TYPES_RR_DEMO2,
  REVIEW_TYPES_RR_DEV,
  REVIEW_TYPES_RR_PROD,
  REVIEW_TYPES_RR_QA,
  REVIEW_TYPES_RR_STAGE,
} from './envSpecificConstants';
import { getEnvironmentSpecificConstant } from './getEnvironmentSpecificConstant';

const REVIEW_TYPES_RR_MAP = {
  prod: REVIEW_TYPES_RR_PROD,
  demo: REVIEW_TYPES_RR_DEMO,
  demo2: REVIEW_TYPES_RR_DEMO2,
  stage: REVIEW_TYPES_RR_STAGE,
  qa: REVIEW_TYPES_RR_QA,
  dev: REVIEW_TYPES_RR_DEV,
  dev2: REVIEW_TYPES_RR_DEV,
};

const REVIEW_TYPES_RR = getEnvironmentSpecificConstant(
  REVIEW_TYPES_RR_MAP,
  process.env.REACT_APP_ENV_NAME, // Dynamic environment value
  REVIEW_TYPES_RR_DEV // Default fallback
);

export default REVIEW_TYPES_RR;
